import { ChakraProvider as ChakraUIProvider } from "@chakra-ui/react";
import { customSystem } from "../lib/chakra-system";
import { ReactNode } from "react";

interface ChakraProviderProps {
  children: ReactNode;
}

export default function Application({ children }: ChakraProviderProps) {
  return <ChakraUIProvider value={customSystem}>{children}</ChakraUIProvider>;
}
